export default __webpack_public_path__ + "static/media/Confluence.046bb3a6.svg";